export default __webpack_public_path__ + "static/media/logo-smarterchains.0cefde0c.svg";